export const INTERVAL_DELAY = 1000 * 60